import api from './api';

const branchService = {
    // Get all branches with pagination and filters
    getBranches: async (params = {}) => {
        try {
            const response = await api.get('/branches', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to fetch branches' };
        }
    },

    // Get a specific branch
    getBranch: async (branchId) => {
        try {
            const response = await api.get(`/branches/${branchId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to fetch branch' };
        }
    },

    // Create a new branch
    createBranch: async (branchData) => {
        try {
            const response = await api.post('/branches', branchData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to create branch' };
        }
    },

    // Update a branch
    updateBranch: async (branchId, branchData) => {
        try {
            const response = await api.put(`/branches/${branchId}`, branchData);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to update branch' };
        }
    },

    // Delete a branch
    deleteBranch: async (branchId) => {
        try {
            const response = await api.delete(`/branches/${branchId}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to delete branch' };
        }
    },

    // Get active branches for dropdown
    getActiveBranches: async () => {
        try {
            const response = await api.get('/branches-data/active');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to fetch active branches' };
        }
    },

    // Get branch statistics
    getBranchStats: async () => {
        try {
            const response = await api.get('/branches-data/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Failed to fetch branch statistics' };
        }
    }
};

export default branchService;
